'use client'
import React, { ChangeEvent } from 'react'
import styles from './styles.module.scss'

export interface SwitchButtonProps {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  checked: boolean
  color?: 'green' | 'gradient' | 'primary'
}

const SwitchButton: React.FC<SwitchButtonProps> = ({
  onChange,
  checked = false,
  color = 'green',
}) => {
  return (
    <label className={`${styles.label} ${styles?.[color]}`}>
      <input type="checkbox" onChange={onChange} checked={checked} />

      <div className={styles.background}>
        <div className={styles.roundIcon} />
      </div>
    </label>
  )
}

export default React.memo(SwitchButton)
